import { Store } from 'vuex';
import { ProductShared } from '@/modules/products/shared/types';
import { Context } from 'vuex-smart-module';
import CartStore from '../../store';
import CartState from '../../store/state';

export default class CartSharedState {}
